<div class="c-onboardingQuestReward">
  <div class="c-onboardingQuestReward__container">
    <div
      class="c-onboardingQuestReward__background"
      theming
      themingGroup="onboardingquest"
      themingAsset="reward-background"
      [themingOverride]="onboardingQuestRewardModalData?.properties?.assets">
      <span class="title">{{ 'home.live-ops.onboarding-quest.mision-completed' | translate }}</span>

      <span class="subtitle">{{ 'home.live-ops.onboarding-quest.enjoy-reward' | translate }}</span>

      <slotcom-display [classes]="['c-display--onboardingQuest']">
        <div
          displayIcon
          displayIconPos="left"
          class="c-display--coin"></div>
        <span>{{
          onboardingQuestRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate)
        }}</span>
      </slotcom-display>
    </div>
  </div>
</div>
